import React from "react";
import { toast } from "react-toastify";
import { ShareIcon, TrashIcon } from "@heroicons/react/24/outline";

import { makeRequest } from "../../../lib/request";
import Button from "../../atoms/Button";
import { useUserStore } from "../../../store/userStore";

function GalleryExchange({
  postId,
  exchangeTitle,
  exchangeSafe,
  title,
  titleSafe,
  exchange,
}: {
  postId: number;
  exchangeTitle: string;
  exchangeSafe: string;
  title: string;
  titleSafe: string;
  exchange: any;
}) {
  const accessToken = useUserStore((state) => state.accessToken);
  const impersonationToken = useUserStore((state) => state.impersonationToken);
  const roles = useUserStore((state) => state.roles);

  const deletePost = async () => {
    const c = window.confirm(
      "Are you sure you want to delete this post? This will revert this signup and remove experience for the gifter. It may also result in a suspension if a report is present and they do not have valid shipping proof."
    );

    if (!c) {
      return;
    }

    const { status, message } = await makeRequest("admin/gallery", {
      method: "DELETE",
      body: JSON.stringify({ postId }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${impersonationToken || accessToken}`,
      },
    });

    if (!status) {
      toast.error(message);
    } else {
      toast.success("Post deleted.");
      window.location.href = `/`;
    }
  };

  return (
    <div className="order-1 flex flex-row items-center w-full">
      <div className="w-full">
        <div className="w-full flex flex-row items-center">
          <div className="flex flex-row items-center">
            <Button
              style="tertiary"
              className={`justify-center flex flex-row items-center text-text-base font-semibold rounded-lg py-1 ps-1 pe-2`}
              link={`/exchange/${exchange.titleSafe}`}
            >
              <span className="flex flex-row gap-2 items-center">
                <span className="h-[2rem] min-w-[2rem] w-[2rem]">
                  <img
                    src={`https://images.givin.gifts/preset:sharp/resize:fit:720:0:0/format:webp/gravity:sm/plain/https://storage.ethereal.sh/gifts-public/${exchange.picture}`}
                    alt=""
                    className="h-full w-full object-cover object-fit rounded-md"
                    width={32}
                    height={32}
                  />
                </span>
                <span>{exchange.title}</span>
              </span>
            </Button>
          </div>
          <div className="flex flex-row gap-3 ml-auto">
            <div>
              <Button
                style="tertiary"
                className={`justify-center flex flex-row gap-2 items-center ml-auto mr-0 rounded-lg max-md:!px-2`}
                onClick={() => {
                  if (window.navigator.share !== undefined) {
                    window.navigator.share({
                      title: `${exchangeTitle} - ${title}`,
                      url: `https://givin.gifts/gallery/${exchangeSafe}/${titleSafe}`,
                    });
                  } else {
                    toast.success("Link copied to clipboard.");

                    navigator.clipboard.writeText(
                      `https://givin.gifts/gallery/${exchangeSafe}/${titleSafe}`
                    );
                  }
                }}
              >
                <span>
                  <ShareIcon className="w-6 h-6 text-text-base" />
                </span>
                <span className="sr-only md:!not-sr-only text-text-base font-semibold">
                  Share
                </span>
              </Button>
            </div>
            {roles && roles.includes("admin") ? (
              <div className="flex items-center ml-auto mr-0">
                <Button
                  style="tertiary"
                  className={`justify-center flex flex-row gap-2 items-center ml-auto mr-0 rounded-lg max-md:!px-2`}
                  onClick={() => {
                    deletePost();
                  }}
                >
                  <TrashIcon className="w-6 h-6 text-rag-error" />
                  <span className="sr-only md:!not-sr-only text-text-base font-semibold">
                    Delete post
                  </span>
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GalleryExchange;
